var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"$style.open_layout"},[(!_vm.shouldHideSection)?_c('app-header'):_vm._e(),_c('div',{class:_vm.$style.open_content},[_c('div',{class:_vm.$style.open_content_body},[_c('router-view')],1),_c('app-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }